import React from 'react';

import { StyledWrapper } from './emergency-banner.styled';

interface IEmergencyBannerProps {
  text?: string | null;
}

const EmergencyBanner: React.FC<IEmergencyBannerProps> = ({ text }) => {
  if (!text) {
    return null;
  }

  return <StyledWrapper>{text}</StyledWrapper>;
};

export default EmergencyBanner;
